// GLOBAL
import { mapActions, mapState } from 'vuex'
// COMPONENTS
import { CrudCreateButton, CrudForm } from '@/components/reusable_components'
import {
    CrudDialog,
    CrudDataTableDialogPicker,
    ModelDataTable,
} from '@/components/reusable_components/next'
// SERVICES
import AssetDiscountService from '@/services/api/human-resource/asset-discount'
import SalarySettlementService from '@/services/api/salarySettlement'
// PARTIALS
import SalarySettlementGeneratorFields from './fields/generator'
import SalarySettlementListFilters from './filters'
import SalarySettlementListHeaders from './headers'
// COMPONENT
export default {
    beforeMount() {
        this.setTitleTopBar('Liquidaciones de sueldo')
    },
    components: {
        'crud-create-button': CrudCreateButton,
        'crud-data-table': ModelDataTable,
        'crud-data-table-dialog-picker': CrudDataTableDialogPicker,
        'crud-dialog': CrudDialog,
        'crud-form': CrudForm,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        buttonProps() {
            return {
                ...this.buttonStatics,
                action: this.submitCreate,
            }
        },

        /**
         *
         */
        dialogFormProps() {
            return {
                title: 'asignar bonos y des monto',
                width: 1080,
            }
        },

        /**
         *
         */
        dialogTableProps() {
            return {
                editable: true,
                filters: AssetDiscountService.filters,
                headers: [
                    ...AssetDiscountService.headers,
                    {
                        text: 'monto',
                        align: 'center',
                        format: 'currency',
                        input: {
                            prefix: '$',
                        },
                        value: 'amount',
                        width: 200,
                    },
                ],
                mapper: this.mapDialogTablePicker,
                noClose: true,
                paramSearch: 'name',
                selectedOne: true,
                service: AssetDiscountService,
                submitIcon: 'attach_money',
                submitText: 'confirmar asignación',
                title: 'seleccionar bonos y/o descuentos',
                width: 1080,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                ...this.tableStatics,
                filters: SalarySettlementListFilters,
                headers: SalarySettlementListHeaders,
                service: SalarySettlementService,
                paramFilter: this.paramFilter,
            }
        },
    },
    created() {
        /**
         *
         */
        this.buttonStatics = {
            text: 'crear liquidación de sueldo',
        }

        /**
         *
         */
        this.searchProps = {
            appendIcon: 'event',
            hideDetails: true,
            //label: '2019-06',
            outline: true,
            singleLine: true,
        }

        /**
         *
         */
        this.tableStatics = {
            checkable: true,
            //noRemove: true,
            noSearch: true,
            ref: 'table',
        }
    },
    data() {
        return {
            dialogDatePicker: false,
            dialogForm: false,
            dialogFormAmount: false,
            dialogTablePicker: false,
            generatorFields: SalarySettlementGeneratorFields,
            search: '',
            selected: null,
            selectedDiscount: null,
            selectedSalaries: [],
            selectedPeriod: null,
            paramFilter: {},
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        mapDialogTablePicker: item => ({ ...item, amount: '0' }),
        mapSelectedDiscount: ({ id, amount }) => ({ id, amount }),
        mapSelectedSalary: ({ id }) => ({ id }),

        /**
         *
         */
        selectedTable(event) {
            this.selectedSalaries = event.selected
        },

        /**
         *
         */

        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        async submitAssign() {
            //
            const hr_salary_settlement = this.selectedSalaries.map(
                    this.mapSelectedSalary
                ),
                hr_salary_settlement_asset_discount = this.selectedDiscount.map(
                    this.mapSelectedDiscount
                )

            //
            const {
                error,
                message,
                status,
            } = await SalarySettlementService.assignMassiveDiscounts({
                hr_salary_settlement,
                hr_salary_settlement_asset_discount,
            })

            //
            switch (status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar('error', 'Error.', error || message)
                    this.$refs.table.refresh()
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Liquidaciónes de sueldo generadas.'
                    )
                    this.$refs.table.refresh()
                    break
                default:
                    this.resetSnackbarState()
                    break
            }
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'salary-settlement-create' })
        },

        /**
         *
         */
        submitDialogAllocator(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('asignar item')
            this.showSnackbar('warning', '¿Desea asignar el item seleccionado?')

            //
            this.selectedDiscount = event.selected
        },

        /**
         *
         */
        submitDialogDatePicker() {
            //
            this.$refs.dialogDatePicker.save(this.search)

            //
            this.paramFilter = {
                period_month: this.search.split('-').pop(),
                period_year: this.search.split('-').shift(),
            }

            //
            //this.$refs.table.refresh()

            //
            this.dialogDatePicker = false
        },

        /**
         *
         */
        async submitDialogGenerator(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('generar liquidaciónes')
            this.showSnackbar(
                'warning',
                '¿Desea generar liquidaciónes de forma masiva?'
            )

            //
            this.selectedPeriod = event.period
        },

        /**
         *
         */
        submitDialogTablePicker(event) {
            //
            this.dialogFormAmount = true
        },

        /**
         *
         */
        submitDetail(event) {
            this.$router.push({
                name: 'salary-settlement-update',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        async submitGenerate() {
            //
            const period_month = parseInt(
                    this.selectedPeriod.split('-').pop(),
                    10
                ),
                period_year = parseInt(
                    this.selectedPeriod.split('-').shift(),
                    10
                )

            //
            const {
                error,
                message,
                status,
            } = await SalarySettlementService.generateMassiveSalaries({
                period_month,
                period_year,
            })

            //
            switch (status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar('error', 'Error.', error || message)
                    this.$refs.table.refresh()
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Liquidaciónes de sueldo generadas.'
                    )
                    this.$refs.table.refresh()
                    break
                default:
                    this.resetSnackbarState()
                    break
            }
        },

        /**
         *
         */
        async submitRemove() {
            //
            const {
                error,
                message,
                status,
            } = await SalarySettlementService.delete(this.selected)

            //
            switch (status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar('error', 'Error.', error || message)
                    this.$refs.table.refresh()
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Liquidación de sueldo eliminada.'
                    )
                    this.$refs.table.refresh()
                    break
                default:
                    this.resetSnackbarState()
                    break
            }
        },

        /**
         *
         */
        submitTableRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar liquidación')
            this.showSnackbar('warning', '¿Desea eliminar la liquidación?')

            //
            this.selected = event.item.id
        },
    },
    watch: {
        /**
         *
         */
        responseConfirm(value) {
            switch (value) {
                case 'asignar item':
                    this.submitAssign()
                    break
                case 'eliminar liquidación':
                    this.submitRemove()
                    break
                case 'generar liquidaciónes':
                    this.submitGenerate()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_SALARY_SETTLEMENT')) ctx.$router.push('/')
        })
    },
}
